// extracted by mini-css-extract-plugin
export default {"centered":"AuthGate_centered__nsx+M","title":"AuthGate_title__jAXLM","error":"AuthGate_error__CdRAD","muted":"AuthGate_muted__6zr5J","button":"AuthGate_button__SxNPA"};